const LazyLoad = {
  init(el, val, defaultSrc) {
    el.setAttribute("data-src", val);
    el.setAttribute("src", defaultSrc);
  },
  observe(el) {
    var io = new IntersectionObserver((entries) => {
      const realSrc = el.dataset.src;
      if (entries[0].isIntersecting) {
        if (realSrc) {
          el.src = realSrc;
          el.removeAttribute("data-src");
        }
      }
    });
    io.observe(el);
  },
};
const lazyLoad = {
  bind(el, binding) {
    LazyLoad.init(
      el,
      binding.value,
      "//code.xueersi.com/static/images/code-home/qrlogo.png" // 默认图片
    );
  },
  inserted(el) {
    LazyLoad.observe(el);
  },
};
export default lazyLoad;
